import { render, staticRenderFns } from "./PackageList.vue?vue&type=template&id=2a6f93e1&scoped=true&"
import script from "./PackageList.vue?vue&type=script&lang=ts&"
export * from "./PackageList.vue?vue&type=script&lang=ts&"
import style0 from "./PackageList.vue?vue&type=style&index=0&id=2a6f93e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6f93e1",
  null
  
)

export default component.exports